import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { FitEdgeToViewEvent } from 'components/Graph/model/GraphCommandEvents';

export type FitEdgeToViewCommand = FitEdgeToViewEvent;

export const fitEdgeToView: GraphCommandFactory<FitEdgeToViewCommand> =
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.emit('fitEdgeToView', command);
  };
